import { Button } from "./components/Button";
import { RoundContainer } from "./components/RoundContainer";

// Logos removed per request; use clear text descriptions instead

export const App = () => {
    const resolveUrl = (value: string | undefined, fallback: string) => {
        if (!value) return fallback;
        const trimmed = value.trim();
        // Ignore unreplaced placeholders like __ENDRE_URL__
        if (/^__.*__$/.test(trimmed)) return fallback;
        // Only accept absolute http(s) URLs
        if (/^https?:\/\//i.test(trimmed)) return trimmed;
        return fallback;
    };

    const proptechUrl = resolveUrl(
        window.env?.PROPTECH_URL,
        "http://localhost:5174"
    );
    const endreUrl = resolveUrl(window.env?.ENDRE_URL, "http://localhost:5173");

    const handleGoTo = (url: string) => {
        window.location.href = url;
    };

    return (
        <div className="w-full h-full flex items-center justify-center bg-neutral-100">
            <RoundContainer
                withPadding
                shadow="md"
                className="w-full max-w-3xl mx-4"
            >
                <div className="flex flex-col items-center">
                    <h1 className="text-2xl font-semibold text-gray-800 mb-2">
                        Choose an application
                    </h1>
                    <p className="text-gray-600 mb-8">
                        Select where you want to go
                    </p>

                    <div className="grid grid-cols-1 gap-6 w-full sm:grid-cols-2">
                        <RoundContainer
                            withPadding
                            shadow="sm"
                            className="flex flex-col items-center text-center"
                        >
                            <h2 className="text-lg font-medium text-gray-800 mb-1">
                                Proptech
                            </h2>
                            <p className="text-gray-600 mb-4">
                                For property development.
                            </p>
                            <Button
                                size="large"
                                className="w-full justify-center"
                                onClick={() => handleGoTo(proptechUrl)}
                            >
                                Open Proptech
                            </Button>
                        </RoundContainer>

                        <RoundContainer
                            withPadding
                            shadow="sm"
                            className="flex flex-col items-center text-center"
                        >
                            <h2 className="text-lg font-medium text-gray-800 mb-1">
                                Endre
                            </h2>
                            <p className="text-gray-600 mb-4">
                                For long-term grid planning.
                            </p>
                            <Button
                                type="secondary"
                                size="large"
                                className="w-full justify-center"
                                onClick={() => handleGoTo(endreUrl)}
                            >
                                Open Endre
                            </Button>
                        </RoundContainer>
                    </div>
                </div>
            </RoundContainer>
        </div>
    );
};
